import { TenantEntity } from '../TenantEntity'

export class CompanyApplication extends TenantEntity {
  constructor(data) {
    super(data)
  }
  get companyUuid() {
    return this._data.companyUuid
  }
  set companyUuid(companyUuid) {
    this._data.companyUuid = companyUuid
  }

  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }

  get oversea() {
    return this._data.oversea
  }
  set oversea(oversea) {
    this._data.oversea = oversea
  }

  get chineseName() {
    return this._data.chineseName
  }
  set chineseName(chineseName) {
    this._data.chineseName = chineseName
  }

  get cnShortName() {
    return this._data.cnShortName
  }
  set cnShortName(cnShortName) {
    this._data.cnShortName = cnShortName
  }

  get shortName() {
    return this._data.shortName
  }
  set shortName(shortName) {
    this._data.shortName = shortName
  }

  get englishName() {
    return this._data.englishName
  }
  set englishName(englishName) {
    this._data.englishName = englishName
  }

  get address() {
    return this._data.address
  }
  set address(address) {
    this._data.address = address
  }

  get overseasWarehouse() {
    return this._data.overseasWarehouse
  }
  set overseasWarehouse(overseasWarehouse) {
    this._data.overseasWarehouse = overseasWarehouse
  }

  get peer() {
    return this._data.peer
  }
  set peer(peer) {
    this._data.peer = peer
  }

  get customerTypeId() {
    return this._data.customerTypeId
  }
  set customerTypeId(customerTypeId) {
    this._data.customerTypeId = customerTypeId
  }

  get creditDateLimited() {
    return this._data.creditDateLimited
  }
  set creditDateLimited(creditDateLimited) {
    this._data.creditDateLimited = creditDateLimited
  }

  get credit() {
    return this._data.credit
  }
  set credit(credit) {
    this._data.credit = credit
  }

  get signContract() {
    return this._data.signContract
  }
  set signContract(signContract) {
    this._data.signContract = signContract
  }

  get latestContractDate() {
    return this._data.latestContractDate
  }
  set latestContractDate(latestContractDate) {
    this._data.latestContractDate = latestContractDate
  }

  get ifCustomer() {
    return this._data.ifCustomer
  }
  set ifCustomer(ifCustomer) {
    this._data.ifCustomer = ifCustomer
  }

  get ifSupplier() {
    return this._data.ifSupplier
  }
  set ifSupplier(ifSupplier) {
    this._data.ifSupplier = ifSupplier
  }

  get seaExport() {
    return this._data.seaExport
  }
  set seaExport(seaExport) {
    this._data.seaExport = seaExport
  }

  get seaImport() {
    return this._data.seaImport
  }
  set seaImport(seaImport) {
    this._data.seaImport = seaImport
  }

  get airExport() {
    return this._data.airExport
  }
  set airExport(airExport) {
    this._data.airExport = airExport
  }

  get airImport() {
    return this._data.airImport
  }
  set airImport(airImport) {
    this._data.airImport = airImport
  }

  get railwayExport() {
    return this._data.railwayExport
  }
  set railwayExport(railwayExport) {
    this._data.railwayExport = railwayExport
  }

  get integratedJob() {
    return this._data.integratedJob
  }
  set integratedJob(integratedJob) {
    this._data.integratedJob = integratedJob
  }

  get customer() {
    return this._data.customer
  }
  set customer(customer) {
    this._data.customer = customer
  }

  get settlementAgent() {
    return this._data.settlementAgent
  }
  set settlementAgent(settlementAgent) {
    this._data.settlementAgent = settlementAgent
  }

  get bookingAgent() {
    return this._data.bookingAgent
  }
  set bookingAgent(bookingAgent) {
    this._data.bookingAgent = bookingAgent
  }

  get seaCmpAgent() {
    return this._data.seaCmpAgent
  }
  set seaCmpAgent(seaCmpAgent) {
    this._data.seaCmpAgent = seaCmpAgent
  }

  get overseaAgent() {
    return this._data.overseaAgent
  }
  set overseaAgent(overseaAgent) {
    this._data.overseaAgent = overseaAgent
  }

  get designationAgent() {
    return this._data.designationAgent
  }
  set designationAgent(designationAgent) {
    this._data.designationAgent = designationAgent
  }

  get localAgent() {
    return this._data.localAgent
  }
  set localAgent(localAgent) {
    this._data.localAgent = localAgent
  }

  get seaCmp() {
    return this._data.seaCmp
  }
  set seaCmp(seaCmp) {
    this._data.seaCmp = seaCmp
  }

  get airCmp() {
    return this._data.airCmp
  }
  set airCmp(airCmp) {
    this._data.airCmp = airCmp
  }

  get customsBroker() {
    return this._data.customsBroker
  }
  set customsBroker(customsBroker) {
    this._data.customsBroker = customsBroker
  }

  get warehouse() {
    return this._data.warehouse
  }
  set warehouse(warehouse) {
    this._data.warehouse = warehouse
  }

  get truckCmp() {
    return this._data.truckCmp
  }
  set truckCmp(truckCmp) {
    this._data.truckCmp = truckCmp
  }

  get signBillPlaceCompany() {
    return this._data.signBillPlaceCompany
  }
  set signBillPlaceCompany(signBillPlaceCompany) {
    this._data.signBillPlaceCompany = signBillPlaceCompany
  }

  get shipper() {
    return this._data.shipper
  }
  set shipper(shipper) {
    this._data.shipper = shipper
  }

  get consignee() {
    return this._data.consignee
  }
  set consignee(consignee) {
    this._data.consignee = consignee
  }

  get notify() {
    return this._data.notify
  }
  set notify(notify) {
    this._data.notify = notify
  }

  get portAgent() {
    return this._data.portAgent
  }
  set portAgent(portAgent) {
    this._data.portAgent = portAgent
  }

  get forwardingAgent() {
    return this._data.forwardingAgent
  }
  set forwardingAgent(forwardingAgent) {
    this._data.forwardingAgent = forwardingAgent
  }

  get terminalCompany() {
    return this._data.terminalCompany
  }
  set terminalCompany(terminalCompany) {
    this._data.terminalCompany = terminalCompany
  }

  get loadingPlaceCompany() {
    return this._data.loadingPlaceCompany
  }
  set loadingPlaceCompany(loadingPlaceCompany) {
    this._data.loadingPlaceCompany = loadingPlaceCompany
  }

  get dischargePortCompany() {
    return this._data.dischargePortCompany
  }
  set dischargePortCompany(dischargePortCompany) {
    this._data.dischargePortCompany = dischargePortCompany
  }

  get destinationPortCompany() {
    return this._data.destinationPortCompany
  }
  set destinationPortCompany(destinationPortCompany) {
    this._data.destinationPortCompany = destinationPortCompany
  }

  get tradersSign() {
    return this._data.tradersSign
  }
  set tradersSign(tradersSign) {
    this._data.tradersSign = tradersSign
  }

  get factorySign() {
    return this._data.factorySign
  }
  set factorySign(factorySign) {
    this._data.factorySign = factorySign
  }

  get other() {
    return this._data.other
  }
  set other(other) {
    this._data.other = other
  }

  get tradeTypes() {
    return this._data.tradeTypes
  }
  set tradeTypes(tradeTypes) {
    this._data.tradeTypes = tradeTypes
  }

  get creditSelfAssessment() {
    return this._data.creditSelfAssessment
  }
  set creditSelfAssessment(creditSelfAssessment) {
    this._data.creditSelfAssessment = creditSelfAssessment
  }

  get customerProfile() {
    return this._data.customerProfile
  }
  set customerProfile(customerProfile) {
    this._data.customerProfile = customerProfile
  }

  get customerCommission() {
    return this._data.customerCommission
  }
  set customerCommission(customerCommission) {
    this._data.customerCommission = customerCommission
  }

  get applicationReason() {
    return this._data.applicationReason
  }
  set applicationReason(applicationReason) {
    this._data.applicationReason = applicationReason
  }

  get status() {
    return this._data.status
  }
  set status(status) {
    this._data.status = status
  }

  get approvedBy() {
    return this._data.approvedBy
  }
  set approvedBy(approvedBy) {
    this._data.approvedBy = approvedBy
  }

  get dateApproved() {
    return this._data.dateApproved
  }
  set dateApproved(dateApproved) {
    this._data.dateApproved = dateApproved
  }
}
